import React from "react";
import { connect } from "react-redux";
import {
  getPortalUrl,
  getPrimaryButtonColor,
  getPrimaryButtonTextColor,
  getConfirmationMessage
} from "../selectors";
import { BigFilledButton, RightArrowIcon } from "components/Base";

const decorate = connect(state => ({
  portalUrl: getPortalUrl(state),
  buttonColor: getPrimaryButtonColor(state),
  buttonTextColor: getPrimaryButtonTextColor(state),
  confirmationMessage: getConfirmationMessage(state)
}));

const ConfirmationPage = ({
  portalUrl,
  buttonColor,
  buttonTextColor,
  confirmationMessage,
  handlers
}) => {
  return (
    <div
      style={{
        background: "#FFF",
        height: "52vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28 4.375C14.9522 4.375 4.375 14.9522 4.375 28C4.375 41.0477 14.9522 51.625 28 51.625C41.0477 51.625 51.625 41.0477 51.625 28C51.625 14.9522 41.0477 4.375 28 4.375Z"
          fill="#018755"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.1947 36.0252L22.7031 34.5337L37.1566 20.0274C37.6508 19.5332 38.4522 19.5332 38.9465 20.0274L39.5431 20.624C40.0373 21.1183 40.0373 21.9197 39.5431 22.4139L25.9845 36.0252C25.4903 36.5195 24.6889 36.5195 24.1947 36.0252Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.4742 34.5337L25.9826 36.0253C25.4884 36.5195 24.687 36.5195 24.1928 36.0253L18.2535 30.086C17.7592 29.5918 17.7592 28.7904 18.2535 28.2962L18.8501 27.6996C19.3444 27.2053 20.1457 27.2053 20.64 27.6996L27.4742 34.5337Z"
          fill="white"
        />
      </svg>

      <div
        style={{
          color: "#494949",
          textAlign: "center",
          fontSize: 16,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "130%"
        }}
        dangerouslySetInnerHTML={{
          __html: confirmationMessage
        }}
      ></div>

      <BigFilledButton
        RightIcon={RightArrowIcon}
        style={{
          borderRadius: "20px",
          backgroundColor: buttonColor,
          color: buttonTextColor,
          borderColor: buttonColor
        }}
        onClick={() => {
          handlers.setShowAlert(false);

          window.location = portalUrl;
        }}
        mt={5}
      >
        Continue to portal
      </BigFilledButton>
    </div>
  );
};

export default decorate(ConfirmationPage);
